"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLoginInfo = getLoginInfo;
exports.handleDeleteTable = handleDeleteTable;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _auth = require("@/utils/auth");
var _store = _interopRequireDefault(require("@/store"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @description 表格列表中删除最后一页中的唯一一个数据的操作
 */
function handleDeleteTable(length, tableFrom) {
  if (length === 1 && tableFrom.page > 1) return tableFrom.page = tableFrom.page - 1;
}

/**
 * @description 登录后的操作
 */
function getLoginInfo(data) {
  console.log("*******************");
  console.log("登录后将data存到store里面: \n", data);
  console.log("*******************");
  _store.default.commit('user/setMerchantDetail', data.merchant);
  _store.default.commit('user/SET_TOKEN', data.token);
  _jsCookie.default.set('JavaMerInfo', JSON.stringify(data));
  (0, _auth.setToken)(data.token);
  _store.default.commit('product/SET_AdminProductClassify', []);
  _store.default.commit('product/SET_MerProductClassify', []);
  _store.default.commit('merchant/SET_MerchantClassify', []);
  _store.default.commit('merchant/SET_MerchantType', []);
  _store.default.commit('product/SET_ShippingTemplates', []);
  _store.default.commit('mobildConfig/SET_SystemForm', []);
}